import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // 1️⃣ Chequeo inicial de sesión
        supabase.auth.getSession().then(({ data: { session } }) => {
            handleUserChange(session?.user ?? null);
        });

        // 2️⃣ Listener de cambios de auth
        const { data: { subscription } } = supabase.auth.onAuthStateChange(
            (_event, session) => {
                handleUserChange(session?.user ?? null);
            }
        );

        return () => {
            subscription.unsubscribe();
        };
    }, []);

    const handleUserChange = async (currentUser) => {
        setLoading(true);

        // 🔒 NO hay usuario
        if (!currentUser) {
            setUser(null);
            setIsAdmin(false);
            setLoading(false);
            return;
        }

        // 🔎 Verificamos si es admin
        const { data, error } = await supabase
            .from('admin') // 👈 tabla correcta
            .select('role')
            .ilike('email', currentUser.email)
            .single();

        // ❌ NO autorizado
        if (error || data?.role !== 'admin') {
            console.warn('Acceso denegado:', currentUser.email);

            // Guardamos mensaje para Login
            sessionStorage.setItem(
                'auth_error',
                'Acceso restringido: cuenta no autorizada.'
            );

            await supabase.auth.signOut();

            setUser(null);
            setIsAdmin(false);
            setLoading(false);

            // 🔁 Redirección limpia (sin #)
            window.location.replace(`/${process.env.REACT_APP_ADMIN_PATH || 'entrada-comuna'}`);
            return;
        }

        // ✅ ADMIN OK
        setUser(currentUser);
        setIsAdmin(true);
        setLoading(false);
    };

    const logout = async () => {
        await supabase.auth.signOut();
        window.location.replace('/');
    };

    return (
        <AuthContext.Provider value={{ user, isAdmin, loading, logout }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
